import { Footer } from '@/components/elements/footer/Footer'
import { ReviewersContent } from './Reviewers/ReviewersContent'
import { ReviewersProfiles } from './Reviewers/ReviewersProfiles'
import { Header } from '@/elements/header/Header'
import { SEOMetaTags } from '@/components/shared/SEOMetaTags'

export const ReviewersPage = ({ page, reviewers }) => {
  return (
    <>
      <SEOMetaTags metaData={page.metaData} path="/learn/reviewers" />
      <Header />
      <main id="main-content">
        <ReviewersContent page={page} />
        <ReviewersProfiles reviewers={reviewers} />
      </main>
      <Footer />
    </>
  )
}
